import { Fragment, Component } from 'preact';
import { Router, brw } from 'preact-router';
import Header from './header/index';
import Footer from './footer';
import Home from '../routes/home';
import CollabsHeader from '../routes/collabs/collabsheader';

import Audiences from '../routes/audiences/index';
import Insights from '../routes/insights';
import TodoForm from '../routes/Forms';
import Article from '../routes/sharedArticle';
import { createHashHistory } from 'history';

import ReactGA from 'react-ga';
import LetsTalk from './LetsTalk/index';
import NewsLetterFooter from './NewsLetterFooter/index';
import { changeHeaderTheme } from '../utils/changeHeaderTheme';
ReactGA.initialize('UA-151246061-1');
ReactGA.pageview(window.location.pathname + window.location.search);

export default class App extends Component {
	/** Gets fired when the route changes.
   *	@param {Object} event		"change" event from [preact-router](http://git.io/preact-router)
   *	@param {string} event.url	The newly routed URL
   */
	state = {
		locationNow     : '',
		queryParamValue : ''
	};

	handleRoute = (e) => {
		var a = [];
		this.currentUrl = e.url;
		if (e.url != '/') {
			var arr = e.url.split('&');
			for (var i = 0; i < arr.length; i++) {
				a = arr[i].split('=');
				this.setState({ queryParamValue: a[1] });
			}
		}

		switch (e.url) {
			case '/':
				if (e.previous) window.location.reload();
				break;
			case '/audiences':
			case '/insights':
			case '/getintouch':
			case '/collabs':
				this.setState({
					locationNow : e.url
				});
				break;
		}
	};

	componentDidMount() {
		var modalDiv = document.createElement('div');
		modalDiv.setAttribute('id', 'user_modal');
		document.body.appendChild(modalDiv);

		var url = window.location.href;
		if (url.includes('fbclid') && url.includes('/article')) {
			var title = url.split('?title=')[1];
			url = window.location.origin + '/#/article' + '?title=' + title;
			// ?title=CES-2018-Highlight#/
			window.location.replace(url);
		}
		else if (url.includes('/article') && !url.includes('/#/article')) {
			url = url.replace('/article', '/#/article');
			window.location.replace(url);
		}

		window.addEventListener('scroll', () => {
			if (window.scrollY > 0) {
				changeHeaderTheme('white');
			}
			else {
				if (
					window.location.hash == '#/getintouch' ||
					window.location.hash == '#/collabs' ||
					window.location.hash.indexOf('article') > 0
				) {
					changeHeaderTheme('transparent-blue');
				}
				else {
					changeHeaderTheme('transparent');
				}
			}
		});
	}

	render() {
		const { queryParamValue } = this.state;
		var a = [];
		var queryString = window.location.href ? window.location.href.split('?')[1] : window.location.search.slice(1);
		if (queryString) {
			var arr = queryString.split('&');

			for (var i = 0; i < arr.length; i++) {
				// separate the keys and the values
				a = arr[i].split('=');
			}
		}

		const { locationNow, highlight } = this.state;

		const shouldDisplayNewsletterBox = !locationNow.includes('/getintouch');

		return (
			<div id="app">
				{/* <Header /> */}
				<Router onChange={this.handleRoute} history={createHashHistory()}>
					<Home exact path="/" queryParamValue={queryParamValue} />
					<Insights path="/insights" queryParamValue={queryParamValue} />
					<Audiences path="/audiences" queryParamValue={queryParamValue} />
					<CollabsHeader path="/collabs" locationNow={locationNow} queryParamValue={queryParamValue} />

					<Article path="/article" locationNow={locationNow} queryParamValue={queryParamValue} />

					<TodoForm path="/getintouch" locationNow={locationNow} queryParamValue={queryParamValue} />
					<LetsTalk path="/" shouldDisplay={shouldDisplayNewsletterBox} />
					<NewsLetterFooter path="/" />
					<Footer path="/" />
				</Router>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./components/app.js